import React from 'react';
import 'isomorphic-fetch';
import { analyticsApiClient } from '@ikea-customer-self-serve/analytics-api-client';
import PageWrapper from './src/PageWrapper';

export const wrapPageElement = ({ element }) => (
  <>
    <PageWrapper element={element} />
  </>
);
/**
 * Parse pathname in order to verify if current path is homepage
 * This is due to multiple setup of sub paths
 */

export const onRouteUpdate = () => {
  const analytics = analyticsApiClient('spare-parts');
  analytics.sendPageview();
};